import { useTheme } from "@/hooks/useTheme";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa6";

const DarkMode = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    if (theme === "dark") {
      setIsChecked(true);
    } else setIsChecked(false);
  }, [theme]);

  return (
    <div className="flex items-center gap-2">
      <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
        <FaEye size={20} className="text-primary" />
      </div>

      <div className="flex-1">
        <h1 className="font-semibold">Dark Mode</h1>
        <p className="text-[12px] font-medium text-gray-500 dark:text-darkGray">
          Switch app display to your preference
        </p>
      </div>

      <div className="flex items-center">
        <label className="inline-flex cursor-pointer items-center">
          <input
            type="checkbox"
            checked={isChecked}
            className="peer sr-only"
            onChange={toggleTheme}
          />
          <div
            className={`peer relative h-6 w-11 rounded-full bg-gray-200 peer-focus:outline-none ${
              isChecked
                ? "peer-checked:after:translate-x-full peer-checked:after:border-white rtl:peer-checked:after:-translate-x-full"
                : ""
            } after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:bg-white after:transition-all after:content-[''] peer-checked:bg-primary`}
          ></div>
        </label>
      </div>
    </div>
  );
};

export default DarkMode;
